import type { ReactNode } from "react";
import { Footer } from "../Footer";
import styles from "./Layout.module.css";

export type LayoutProps = {
  children: ReactNode;
  nav?: ReactNode;
};

export const Layout = ({ children, nav }: LayoutProps) => (
  <div className={styles.shell}>
    {nav}
    {children}
    <Footer />
  </div>
);
